/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type FilePermissions = 'owner' | 'writer' | 'reader';

export const FilePermissions = {
    Owner: 'owner' as FilePermissions,
    Writer: 'writer' as FilePermissions,
    Reader: 'reader' as FilePermissions
};